import {
  BoxProps,
  Flex,
  Grid,
  GridItem,
  Tag,
  TagLabel,
  Text,
} from "@chakra-ui/react";
import { useSegmentInfo } from ".";
import { DetailField } from "../../components/detailField/DetailField";

export const TargetDetailsSummary = (props: BoxProps) => {
  const { segment } = useSegmentInfo();

  return (
    // <SectionBox {...props}>
      <Flex direction={"column"} {...props}>
        <Grid
          templateColumns="flex"
          gap={2}
          mb={4}
          alignItems={"flex-start"}
        >
          <GridItem colSpan={3}>
            <Text
              color={"primary.darker"}
              fontWeight={"semibold"}
              fontSize={"sm"}
              mr={2}
            >
              Targeting Details:
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <Tag
              size={"sm"}
              bg={segment.active ? "primary.light" : "inactive"}
              colorScheme="teal"
              borderRadius={"full"}
            >
              <TagLabel>{segment.active ? "active" : "inactive"}</TagLabel>
            </Tag>
          </GridItem>
        </Grid>
        {segment.externalId && (
          <DetailField
            label={"ID:"}
            value={segment.externalId}
            isCopyField={true}
            variant={"flex"}
          />
        )}
        <DetailField label={"Name:"} value={segment.name} isCopyField={true} variant={"flex"}/>
      </Flex>
    // </SectionBox>
  );
};
